const toISO8601Format = date => date.toISOString().split('T')[0];

export const getPriceValidUntil = promotion => {
  if (!promotion) return null;
  if (promotion.startDate) {
    const startDate = new Date(promotion.startDate);
    // check if startDate is valid and it's in future
    if (
      !Number.isNaN(startDate.getTime()) &&
      startDate.getTime() > Date.now()
    ) {
      return toISO8601Format(startDate);
    }
  }
  if (promotion.endDate) {
    const endDate = new Date(promotion.endDate);
    // check if endDate is valid and it's in future
    if (!Number.isNaN(endDate.getTime()) && endDate.getTime() > Date.now()) {
      return toISO8601Format(endDate);
    }
  }
  return null;
};
